const MovableView = {
    name: 'movable-view',
    props: {
        offsetLeft: {
            type: Number,
            default: 0
        },
        offsetTop: {
            type: Number,
            default: 0
        },
        mediaInfo: Object
    },
    data() {
        return {
            touch: {
                startX1: 0,
                startX2: 0,
                startY1: 0,
                startY2: 0,
                moveX1: 0,
                moveX2: 0,
                moveY1: 0,
                moveY2: 0,
                endX: 0,
                endY: 0,
                startScale: 0,
                moveScale: 0,
                endScale: 1,
                timeStamp: 0,
                multiFinger: false
            },
            scale: 1,
            moveX: 0,
            moveY: 0,
            width: 0,
            areaWidth: 0,
            height: 0,
            areaHeight: 0,
            initX: 0,
            initY: 0,
            transition: 'transform 0ms',
            isTouch: true,
            isEmit: false
        };
    },
    mounted() {
        if (this.mediaInfo) {
            this.initAreaSize();
        }
        $narwal.on('resize', () => {
            this.initAreaSize();
        });
    },
    computed: {
        moveStyle() {
            return {
                transition: `${this.transition}`,
                transform: `translate3d(${this.moveX + this.initX}px, ${this.moveY + this.initY}px, 0) scale3d(${this.scale}, ${this.scale}, ${this.scale})`
            };
        }
    },
    methods: {
        initAreaSize() {
            if (this.width === 0) {
                this.width = Math.min($narwal.screenWidth, this.mediaInfo.width);
                if (this.mediaInfo.width < $narwal.screenWidth) {
                    this.height = this.mediaInfo.height * this.mediaInfo.width / $narwal.screenWidth;
                } else {
                    this.height = this.mediaInfo.height * $narwal.screenWidth / this.mediaInfo.width;
                }
                this.areaWidth = $narwal.screenWidth;
                this.areaHeight = $narwal.screenHeight;
                if (this.width < this.areaWidth) {
                    this.initX = (this.areaWidth - this.width) / 2;
                }

                if (this.height < this.areaHeight) {
                    this.initY = (this.areaHeight - this.height) / 2;
                }
            }
        },
        onResetTouch() {
            this.scale = 1;
            this.transition = 'transform 0ms';
            this.moveX = 0;
            this.moveY = 0;
            this.touch.endScale = 1;
            this.touch.endX = 0;
            this.touch.endY = 0;
        },
        handleTouchStart(ev) {
            if (this.width === 0 || !this.isTouch) {
                return false;
            }

            this.isEmit = false;
            this.transition = 'transform 0ms';
            this.touch.startX1 = ev.touches[0].pageX;
            this.touch.startY1 = ev.touches[0].pageY;
            if (ev.touches.length > 1) {
                this.touch.startX2 = ev.touches[1].pageX;
                this.touch.startY2 = ev.touches[1].pageY;
                this.touch.startScale = Math.sqrt(Math.pow(this.touch.startX2 - this.touch.startX1, 2) + Math.pow(this.touch.startY2 - this.touch.startY1, 2));
                ev.preventDefault();
                ev.stopPropagation();
            } else if (ev.touches.length === 1) {
                this.touch.timeStamp = Date.now();
            }
        },
        handelTouchMove(ev) {
            if (this.width === 0 || !this.isTouch) {
                return false;
            }

            this.touch.moveX1 = ev.touches[0].pageX;
            this.touch.moveY1 = ev.touches[0].pageY;
            if (ev.touches.length > 1) {
                this.touch.multiFinger = true;
                this.touch.moveX2 = ev.touches[1].pageX;
                this.touch.moveY2 = ev.touches[1].pageY;
                this.touch.moveScale = Math.sqrt(Math.pow(this.touch.moveX2 - this.touch.moveX1, 2) + Math.pow(this.touch.moveY2 - this.touch.moveY1, 2));
                this.scale = this.touch.endScale + (this.touch.moveScale - this.touch.startScale) / 200;
                this.scale = Math.min(3, Math.max(0.3, this.scale));
                this.moveX = this.touch.endX - (this.width * (this.scale - this.touch.endScale)) / 2;
                this.moveY = this.touch.endY - (this.height * (this.scale - this.touch.endScale)) / 2;
                ev.preventDefault();
                ev.stopPropagation();
            } else if (!this.touch.multiFinger && ev.touches.length === 1) {
                const pageX = this.touch.moveX1 - this.touch.startX1;
                const pageY = this.touch.moveY1 - this.touch.startY1;
                this.moveX = pageX + this.touch.endX;
                this.moveY = pageY + this.touch.endY;
                this.transition = 'transform 0ms';

                const maxWidth = this.width * this.scale - this.areaWidth;
                const maxHeight = this.height * this.scale - this.areaHeight;
                if (maxWidth <= 0) {
                    this.moveX = 0;
                }

                if (maxHeight <= 0) {
                    this.moveY = -maxHeight / 2 - this.initY;
                }

                if (this.moveX === 0) {
                    if (Math.abs(pageX) > Math.abs(pageY)) {
                        return false;
                    }
                }

                if (this.moveX !== 0 || this.moveY !== 0) {
                    if (this.moveX > 50 || this.moveX + 50 < -maxWidth) {
                        if (!this.isEmit) {
                            this.isEmit = true;
                            this.$emit('touch', ev);
                        }
                        this.moveX = Math.min(50, Math.max(-maxWidth - 50, this.moveX));
                        return false;
                    }

                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        },
        handleTouchEnd(ev) {
            if (this.width === 0 || !this.isTouch) {
                return false;
            }

            this.isTouch = false;
            if (this.touch.multiFinger) {
                this.transition = 'transform 300ms';
                if (this.scale < 1) {
                    this.scale = 1;
                    this.moveX = 0;
                    this.moveY = 0;
                } else {
                    const maxWidth = this.width * this.scale - this.areaWidth;
                    const maxHeight = this.height * this.scale - this.areaHeight;
                    this.moveX = Math.min(-this.initX, Math.max(-maxWidth - this.initX, this.moveX));
                    if (maxHeight <= 0) {
                        this.moveY = -maxHeight / 2 - this.initY;
                    } else {
                        this.moveY = Math.min(-this.initY, Math.max(-maxHeight - this.initY, this.moveY));
                    }
                }
            } else if (this.touch.timeStamp !== 0) {
                const mod = Date.now() - this.touch.timeStamp;
                const pageX = ev.changedTouches[0].pageX;
                const pageY = ev.changedTouches[0].pageY;
                const distanceX = pageX - this.touch.startX1;
                const distanceY = pageY - this.touch.startY1;
                const maxWidth = this.width * this.scale - this.areaWidth;
                const maxHeight = this.height * this.scale - this.areaHeight;
                const speedX = (distanceX / mod) * 200;
                const speedY = (distanceY / mod) * 200;
                this.transition = 'transform 500ms cubic-bezier(0.1, 0.57, 0.1, 1)';
                if (this.moveX !== 0) {
                    this.moveX += speedX;
                    this.moveX = Math.min(-this.initX, Math.max(-maxWidth - this.initX, this.moveX));
                }

                if (maxHeight <= 0) {
                    this.moveY = -maxHeight / 2 - this.initY;
                } else {
                    this.moveY += speedY;
                    this.moveY = Math.min(-this.initY, Math.max(-maxHeight - this.initY, this.moveY));
                }

                const x = Math.abs(this.touch.startX1 - pageX) < 5;
                const y = Math.abs(this.touch.startY1 - pageY) < 5;
                this.touch.timeStamp = 0;
                this.touch.startX1 = 0;
                this.touch.startY1 = 0;
                if (mod < 200 && x && y) {
                    this.$emit('select', {
                        pageX,
                        pageY
                    });
                }
            }

            this.touch.endScale = this.scale;
            this.touch.endX = this.moveX;
            this.touch.endY = this.moveY;
            this.touch.multiFinger = false;
            setTimeout(() => {
                this.isTouch = true;
            }, 50);
        }
    },
    render() {
        return Vue.createVNode('div', {
            class: ['m-movable-area', { done: this.width > 0 }],
            onTouchstart: this.handleTouchStart,
            onTouchmove: this.handelTouchMove,
            onTouchend: this.handleTouchEnd
        }, [
            Vue.createVNode('div', {
                ref: 'movableView',
                style: this.moveStyle,
                class: 'movable-view'
            }, this.$slots.default ? this.$slots.default() : [])
        ]);
    }
};

const previewImage = {
    renderCSS: () => {
        return `.m-movable-area{width:100vw;height:auto;overflow:hidden;}.m-movable-area.done{height:100vh;}.m-movable-area .movable-view{transform-origin:left top;}
        .m-preview-media{width:100%;height:100%;position:fixed;background-color:#000000;left:0;top:0;z-index:99999999999;}.m-preview-media .close{position:absolute;right:10px;top:10px;z-index:9;}.m-preview-media .close .icon{width:30px;height:30px;}.m-preview-media .progress{color:#FFF;font-size:16px;line-height:24px;height:48px;border-radius:18px;position:absolute;left:50%;transform:translateX(-50%);top:10px;z-index:2;}.m-preview-media .preview-media-swiper{width:100%;height:100vh;}.m-preview-media .preview-media-swiper .media-item{width:100%;}.m-preview-media .preview-media-swiper .image-wrap{width:100%;max-height:100vh;}@media screen and (min-width:1024px){.m-preview-media{background-color:#FFFFFF;left:50%;top:50%;transform:translate3d(-50%,-50%,0);width:90vw;height:90vh;box-shadow:0 0 0 1000px rgba(0,0,0,0.4);border-radius:12px;overflow:hidden;box-sizing:border-box;padding-top:20px;}.m-preview-media .close{cursor:pointer;}.m-preview-media .close:hover .icon path{fill-opacity:1;}.m-preview-media .close .icon path{fill:#000000;transition:all 0.5s;}.m-preview-media .close .icon path:nth-child(2){fill:#FFFFFF;}.m-preview-media .preview-media-swiper{height:70vh;}.m-preview-media .preview-media-swiper .media-item{height:100%;object-fit:contain;}.thumbnail-items{width:100%;margin-top:20px;}.thumbnail-items .thumbnail-item{width:60px;height:60px;border-radius:4px;overflow:hidden;border:1px solid #DBDBDD;box-sizing:border-box;margin:0 8px;cursor:pointer;}.thumbnail-items .thumbnail-item.active{border-color:#683DF5;}.thumbnail-items .thumbnail-item .image{width:100%;height:100%;object-fit:contain;}}`;
    },
    renderHTML: () => {
        return `<div class="m-preview-media" @click="handleClose('fill')" v-show="visible">
                    <div class="swiper-container preview-media-swiper" ref="swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide flex-center" v-for="(item, index) in sources" :key="index">
                                <movable-view
                                    v-if="isMobile"
                                    class="image-wrap"
                                    @touch="handleTouch"
                                    :media-info="item"
                                    :ref="'movable'+index">
                                        <img v-if="visible" alt="" class="media-item" :src="item.url"/>
                                </movable-view>
                                 <img v-else-if="!isMobile && visible" alt="" class="media-item" :src="item.url"/>
                            </div>
                        </div>
                    </div>
                    <div
                        class="progress"
                        v-show="sources.length > 1 && isMobile">{{ current+1 }}&nbsp;&nbsp;/&nbsp;&nbsp;{{ sources.length }}
                    </div>
                    <div class="thumbnail-items flex-center" v-if="visible && !isMobile">
                        <div @click="onChangeSlide(index)" class="thumbnail-item" :class="{active: current===index}" v-for="(item, index) in sources" :key="index">
                            <img alt="" class="image" :src="item.url"/>
                        </div>
                    </div>
                    <div class="close flex-center" @click="handleClose('close')">
                        <svg t="1748499637379" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6585" width="64" height="64"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#FFFFFF" fill-opacity=".5" p-id="6586" data-spm-anchor-id="a313x.manage_type_myprojects.0.i5.2d613a81F1F9CZ" class="selected"></path><path d="M331.008 331.008a32 32 0 0 1 45.248 0L512 466.688l135.744-135.68a32 32 0 1 1 45.248 45.248L557.312 512l135.68 135.744a32 32 0 1 1-45.248 45.248L512 557.312l-135.744 135.68a32 32 0 0 1-45.248-45.248L466.688 512l-135.68-135.744a32 32 0 0 1 0-45.248z" fill="#FFFFFF" p-id="6587" data-spm-anchor-id="a313x.manage_type_myprojects.0.i4.2d613a81F1F9CZ" class="selected"></path></svg>
                    </div>
                </div>`;
    },
    __vm__: null,
    init: () => {
        const header = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.innerHTML = previewImage.renderCSS();
        header.appendChild(style);
        const node = document.createElement('div');
        node.innerHTML = previewImage.renderHTML();
        document.body.appendChild(node);

        previewImage.__vm__ = Vue.createApp({
            data() {
                return {
                    sources: [],
                    current: 0,
                    visible: false,
                    done: false,
                    isMobile: $narwal.screenWidth <= 1024
                };
            },
            computed: {
                moveStyle() {
                    return {
                        transition: `${this.transition}`,
                        transform: `translate3d(${this.moveX + this.initX}px, ${this.moveY + this.initY}px, 0) scale3d(${this.scale}, ${this.scale}, ${this.scale})`
                    };
                }
            },
            components: {
                MovableView
            },
            mounted() {
                this.onInitSwipe();
                $narwal.on('resize', () => {
                    this.isMobile = $narwal.isMobile;
                    this.$nextTick(() => {
                        this.swiper.updateSlides();
                    });
                });
            },
            methods: {
                onShow(index) {
                    this.visible = true;
                    this.swiper.slideTo(index, 0);
                    document.body.style.overflow = 'hidden';
                    setTimeout(() => {
                        this.done = true;
                    }, 300);
                    this.$nextTick(() => {
                        this.swiper.updateSlides();
                    });
                },
                onChangeImage(list) {
                    const sources = [];
                    list.forEach(item => {
                        const arr = item.split('size=')[1].split('-');
                        sources.push({
                            url: item,
                            width: arr[0],
                            height: arr[1]
                        });
                    });
                    this.sources = sources;
                    this.$nextTick(() => {
                        this.swiper.updateSlides();
                    });
                },
                onInitSwipe() {
                    this.swiper = new window.Swiper(this.$refs.swiper, {
                        slidesPerView: 'auto',
                        initialSlide: 0,
                        on: {
                            slideChangeTransitionStart: ({ realIndex }) => {
                                this.prev = this.current;
                                this.current = realIndex;
                            },
                            slideChangeTransitionEnd: () => {
                                if (this.prev !== null && this.isMobile) {
                                    this.$refs[`movable${this.prev}`]?.[0]?.onResetTouch();
                                }
                            }
                        }
                        // navigation: {
                        //     nextEl: `#{{ section.id }}-products .arrow-next`,
                        //     prevEl: `#{{ section.id }}-products .arrow-prev`
                        // }
                    });
                },
                onChangeSlide(index) {
                    this.current = index;
                    this.swiper.slideTo(index);
                },
                handleClose(type) {
                    if (type === 'fill' && !this.isMobile) {
                        return false;
                    }

                    if (this.done) {
                        this.visible = false;
                        this.done = false;
                        document.body.style.overflow = '';
                    }
                },
                handleTouch(ev) {
                    const swipe = this.$refs.swiper;
                    const touch = ev.touches[0];
                    var clickEvent = new TouchEvent(
                        'touchstart',
                        {
                            touches: [touch],
                            changedTouches: [touch],
                            targetTouches: [touch],
                            target: swipe
                        }
                    );
                    swipe.dispatchEvent(clickEvent);
                }
            }
        }).mount(node);
    },
    changeImage(list) {
        previewImage.__vm__.onChangeImage(list);
    },
    onShow(index) {
        previewImage.__vm__.onShow(index);
    }
};